import { Shimmer, ShimmerElementType } from "@fluentui/react";
import { shimmerSectionStyles } from "./GeneralLoadingSkeletons";

// eslint-disable-next-line
export const PolicyInfoShimmer = () => {
  return (
    <div style={{ padding: 0, width: '100%' }}>
      {/* Title shimmer */}
      <Shimmer
        style={{ marginBottom: '16px' }}
        width="60%"
        shimmerElements={[{ type: ShimmerElementType.line, height: 36 }]}
      />
      {/* Action bar shimmer */}
      <Shimmer
        style={{ marginBottom: '24px' }}
        width="50%"
        shimmerElements={[
          { type: ShimmerElementType.line, width: '15%', height: 28 },
          { type: ShimmerElementType.gap, width: '2.5%' },
          { type: ShimmerElementType.line, width: '20%', height: 28 },
        ]}
      />
      {/* Metadata section shimmer */}
      <Shimmer
        style={{ marginBottom: '24px' }}
        width="420px"
        shimmerElements={[{ type: ShimmerElementType.line, width: '100%', height: 150 }]}
      />
      {/* Description shimmer */}
      <Shimmer
        style={{ marginBottom: '8px' }}
        width="120px"
        shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]}
      />
      <Shimmer
        width="80%"
        shimmerElements={[{ type: ShimmerElementType.line, height: 40 }]}
      />
    </div>
  );
};

// eslint-disable-next-line
export const PolicyActionBarShimmer = () => {
  const shimmerElements = [
    { type: ShimmerElementType.line, width: "15%", height: 28 },
    { type: ShimmerElementType.gap, width: "2.5%" },
    { type: ShimmerElementType.line, width: "20%", height: 28 },
  ];

  return (
    <Shimmer
      style={shimmerSectionStyles}
      width="50%"
      shimmerElements={shimmerElements}
    />
  );
};

// eslint-disable-next-line
export const PolicyMetadataShimmer = () => {
  const shimmerElements = [
    { type: ShimmerElementType.line, width: "100%", height: 150 },
  ];

  return (
    <Shimmer
      style={shimmerSectionStyles}
      width="420px"
      shimmerElements={shimmerElements}
    />
  );
};
